export default class AddonFilter {
    constructor()
    {
        this.dropdownSelector = document.getElementById('addon-dropdown-select');
        this.addonProducts = document.querySelectorAll('.addon-product');
        this.init();

    }

    init() {
        const dropdown = this.dropdownSelector;
        if (!dropdown) return;
        dropdown.addEventListener('change', (e) => {
            const selectedIndex = dropdown.selectedIndex;
            const selectedValue = dropdown.value;
            const addonProducts = this.addonProducts;

            addonProducts.forEach(el => {
                const matches = !selectedValue || selectedIndex === 0 ||  selectedValue === '' || selectedValue === '0' || //Default no filter
                    el.getAttribute('data-category-id') === selectedValue;

                if (matches) {
                    el.classList.remove('d-none');
                    el.classList.add('d-flex');
                } else {
                    el.classList.remove('d-flex');
                    el.classList.add('d-none');
                }
            });
        });
    }
}
    
